<div class="status color generalstatus" [ngClass]="generalClass"></div>
<div class="content">
    <div class="slot-overbooked-banner">{{ 'SLOTSERVICE.ERROR.OVERBOOKING' | translate }}</div>
    <ng-content></ng-content>
    <div class="slot-invalidreservation-banner">{{ 'SLOTSERVICE.ERROR.INVALIDRESERVATION' | translate }}</div>
    <ng-content></ng-content>
    <div class="slot-linkedslot-banner">{{ 'SLOTSERVICE.INFO.LINKEDSLOT' | translate }}</div>
    <ng-content></ng-content>
</div>